// extracted by mini-css-extract-plugin
export default {"component":"SummaryTranscription_component__M54dw"};